<fieldset>
  <label [raskRequired]="required">
    {{label}}
    @if (infoText) {
      <rask-info>{{infoText}}</rask-info>
    }
  </label>
  <ng-select #instance
    id="{{aid}}"
    [addTag]="true"
    clearAllText="{{clearAllTooltipText}}"
    [items]="[]"
    [multiple]="true"
    [selectOnTab]="true"
    [isOpen]="false"
    [(ngModel)]="selected"
    [ngModelOptions]="{standalone: true}"
    (change)="onSelectionChange($event)">
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
      @for (item of items; track item) {
        <div class="ng-value">
          <span class="ng-value-label">{{item}}</span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"><i class="fal fa-times"></i></span>
        </div>
      }
    </ng-template>
  </ng-select>
  @if (rule) {
    <rask-validation-message [rule]="rule"></rask-validation-message>
  }
</fieldset>